import { useState, useEffect } from "react";



function ProfileTicketEdit(props){

    //const [name, setName] = useState("");
    //const [surname, setSurname] = useState("");
    //setPhone={setPhone} setCompany={setCompany} setIndustry={setIndustry} setVat={setVat} 

    //industry={industry} name={name} surname={surname} phone={phone} vat={vat} company={company} 

    return (
       
        <>

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Personal Information </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
       {/* invalid */}
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm  "
            name=""
            value={props.name}
            placeholder="Name"
            style={{ marginTop: "10px" }}
            onChange={(e) => {
                props.setName(e.target.value);
              }}
            />
               <div class="invalid-feedback">
                Please provide a valid Name.
            </div>
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            value={props.surname}
            placeholder="Surname"
            style={{ marginTop: "10px" }}
            onChange={(e) => {
                props.setSurname(e.target.value);
              }}
            />
        </div>
    </div>

</div>

<div class="row">


    <div class="col-sm-6">


          <div className="">
        
            <input
            type="tel"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            value={props.phone}
            placeholder="Phone"
            style={{ marginTop: "10px" }}
            onChange={(e) => {
            props.setPhone(e.target.value);
              }}
            />
        </div>
    </div>

    {/* 
    <div class="col-sm-6">
          <div className="">
         
            <input
            type="tell"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Alternate Phone "
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>
    */}

</div>

<div class="row">

<div class="col-sm-12">
<hr style={{marginTop:"50px", marginBottom:"50px"}} />
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Company Information </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            value={props.company}
            placeholder="Company Name"
            style={{ marginTop: "10px" }}
            onChange={(e) => {
            props.setCompany(e.target.value);
                  }}
            />
         
        </div>
    </div>

    <div class="col-sm-6">
    <div className="">
        
        <select  id="cars" name="cars" className="Login-form-field Login-animation a4 ProgressForm selectForm" style={{ marginTop: "10px" }} value={props.industry} onChange={(e) => {
                props.setIndustry(e.target.value);
              }}>
        <option value="" disabled selected>Industry Type</option>
  <option value="Installer">Installer</option>
  <option value="Reseller">Reseller</option>
  <option value="Installer & Reseller">Installer & Reseller</option>
  <option value="Other">Other</option>
</select>



      </div>
    </div>

</div>

<div class="row">

<div class="col-sm-12">

</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            value={props.vat}
            placeholder="VAT Number"
            style={{ marginTop: "10px" }}
            onChange={(e) => {
            props.setVat(e.target.value);
                      }}
            />
        </div>
    </div>
    {/* 

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="City"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>
*/}
</div>
        </>
    )
}

export default ProfileTicketEdit;


